export default class OTPForm {
  static newCodeWaitForSecs = 30;

  static init() {
    self.resendCodeBtn = document.querySelector(".js-otp-resend-code");
    if ( self.resendCodeBtn ) {
      self.enableResendCodeButtonLater();
      self.resendCodeBtn.addEventListener("click", self.resendCode);
    }
  }

  static resendCode() {
    self.resendCodeBtn.disabled = true;
    self.resendCodeBtn.innerHTML = self.resendCodeBtn.dataset.inactiveText;

    fetch(self.resendCodeBtn.dataset.url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": self.csrfToken,
        "Content-Type": "application/json",
      },
    }).then(async (r) => {
      if ( r.redirected ) {
        window.location.href = r.url;
      } else {
        const json = await r.json();
        self.resendCodeBtn.dataset.secondsLeft = json.otp_seconds_left;
        self.enableResendCodeButtonLater()
      }
    });
  }

  static enableResendCodeButtonLater() {
    self.secondsLeft = parseInt(self.resendCodeBtn.dataset.secondsLeft);

    self.updateButtonText();
    self.timer = setInterval(() => {
      if ( self.secondsLeft <= 0 ) {
        self.resendCodeBtn.disabled = false;
        clearInterval(self.timer);
      } else {
        self.secondsLeft -= 1;
      }

      self.updateButtonText();
    }, 1000);
  }

  static updateButtonText() {
    self.resendCodeBtn.innerHTML = self.secondsLeft <= 0 ?
      self.resendCodeBtn.dataset.activeText :
      self.resendCodeBtn.dataset.inactiveText.replace("##", self.humanizeSeconds(self.secondsLeft));
  }

  static humanizeSeconds(secs) {
    const minsLeft = Math.floor(secs / 60);
    const secsLeft = secs % 60;
    return `${minsLeft.toString().padStart(2, '0')}:${secsLeft.toString().padStart(2, '0')}`;
  }
}

const self = OTPForm;
self.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
